import React from 'react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  label?: string;
  fullScreen?: boolean;
}

const sizeClasses = {
  sm: 'w-4 h-4 border-2',
  md: 'w-8 h-8 border-2',
  lg: 'w-12 h-12 border-[3px]',
  xl: 'w-16 h-16 border-4',
};

export function LoadingSpinner({
  size = 'md',
  label = 'Loading…',
  fullScreen = false,
}: LoadingSpinnerProps): React.ReactElement {
  const spinner = (
    <div className="flex flex-col items-center gap-3">
      <div
        className={[
          'rounded-full border-primary-500/30 border-t-primary-500 animate-spin',
          sizeClasses[size],
        ].join(' ')}
        role="status"
        aria-label={label}
      />
      {label && (
        <p className="text-sm text-slate-500 animate-pulse">{label}</p>
      )}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-surface-900/80 backdrop-blur-sm z-50">
        {spinner}
      </div>
    );
  }

  return spinner;
}
